
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-detail/[product]",
      function () {
        return require("private-next-pages/product-detail/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-detail/[product]"])
      });
    }
  